// @flow
const ITEM_TYPE_FILE: 'file' = 'file';
const ITEM_TYPE_FOLDER: 'folder' = 'folder';
const ITEM_TYPE_HUBS: 'hubs' = 'hubs';
const ITEM_TYPE_WEBLINK: 'web_link' = 'web_link';

const JSON_PATCH_OP_ADD: 'add' = 'add';
const JSON_PATCH_OP_REMOVE: 'remove' = 'remove';
const JSON_PATCH_OP_REPLACE: 'replace' = 'replace';
const JSON_PATCH_OP_TEST: 'test' = 'test';

const METADATA_FIELD_TYPE_ENUM: 'enum' = 'enum';
const METADATA_FIELD_TYPE_MULTISELECT: 'multiSelect' = 'multiSelect';

export {
    ITEM_TYPE_FILE,
    ITEM_TYPE_FOLDER,
    ITEM_TYPE_HUBS,
    ITEM_TYPE_WEBLINK,
    JSON_PATCH_OP_ADD,
    JSON_PATCH_OP_REMOVE,
    JSON_PATCH_OP_REPLACE,
    JSON_PATCH_OP_TEST,
    METADATA_FIELD_TYPE_ENUM,
    METADATA_FIELD_TYPE_MULTISELECT,
};
